/** `system` module DTOs' unique keys */
export enum SystemDtoKeysEnum {
  /** Application global configuration */
  APP_CONFIG_FIND_DTO = 'system/app-config-find.dto',
  /** "BullMQ" job description response body */
  BULL_MQ_JOB_FIND_DTO = 'system/bull-mq-job-history-job.dto',
  /** "BullMQ" page widget APIs common query parameters */
  BULL_MQ_WIDGET_QUERY_DTO = 'system/bull-mq-widget-query.dto',
  /** "BullMQ" job add API response body */
  BULL_MQ_ADD_JOB_FIND_DTO = 'system/bull-mq-add-job-find.dto',
  /** "BullMQ" job add API request body */
  BULL_MQ_ADD_JOB_FORM_DTO = 'system/bull-mq-add-job-form.dto',
  /** "BullMQ" history log entry response body */
  BULL_MQ_JOB_HISTORY_ENTRY_DTO = 'system/bull-mq-job-history-entry.dto',
  /** "BullMQ" history log filters */
  BULL_MQ_JOB_HISTORY_FILTERS_DTO = 'system/bull-mq-job-history-filters.dto',
  /** "BullMQ" job history log API response body */
  BULL_MQ_JOB_HISTORY_PAGE_DTO = 'system/bull-mq-job-history-page.dto',
  /** "BullMQ" job history log API query parameters */
  BULL_MQ_JOB_HISTORY_QUERY_DTO = 'system/bull-mq-job-history-query.dto',
  /** Changelog message response body */
  CHANGELOG_FIND_DTO = 'system/changelog-find.dto',
  /** Changelog message create and update APIs request body */
  CHANGELOG_FORM_DTO = 'system/changelog-form.dto',
  /** Changelog description block */
  CHANGELOG_DESCRIPTION_BLOCK_DTO = 'system/changelog-description-block.dto',
  /** Changelog messages list API base filters */
  CHANGELOG_PAGE_FILTERS_DTO = 'system/changelog-page-filters.dto',
  /** Changelog messages list API query parameters */
  CHANGELOG_PAGE_QUERY_DTO = 'system/changelog-page-query.dto',
  /** Change log messages list API response body */
  CHANGELOG_PAGE_DTO = 'system/changelog-page.dto',
  /** Changelog single message APIs URL parameters */
  CHANGELOG_PARAMS_DTO = 'system/changelog-params.dto',
  /** Event emit history log entry */
  EVENT_EMIT_HISTORY_ENTRY_DTO = 'system/event-emit-history-entry.dto',
  /** Event emit history own filters */
  EVENT_EMIT_HISTORY_FILTERS_DTO = 'system/event-emit-history-filters.dto',
  /** Event emit history log API response body */
  EVENT_EMIT_HISTORY_PAGE_DTO = 'system/event-emit-history-page.dto',
  /** Event emit history log API query parameters */
  EVENT_EMIT_HISTORY_QUERY_DTO = 'system/event-emit-history-query.dto',
  /** Envelope of event emitted by remote service */
  EVENT_REMOTE_ENVELOPE_DTO = 'system/event-remote-envelope.dto',
  /** "BullMQ" queues concurrency settings */
  BULL_MQ_CONFIG_CONCURRENCY_DTO = 'system/bull-mq-config-concurrency.dto',
  /** "BullMQ" configuration */
  BULL_MQ_CONFIG_DTO = 'system/bull-mq-config.dto',
  /** Voice assistant configuration */
  VOICE_ASSISTANT_CONFIG_DTO = 'system/voice-assistant-config.dto',
  /** Remote config APIs common URL parameters */
  REMOTE_CONFIG_PARAMS_DTO = 'system/remote-config-params.dto',
  /** Technical work slot response body */
  UNDER_CONSTRUCTION_FIND_DTO = 'system/under-construction-find.dto',
  /** Technical work slot create and update APIs request body */
  UNDER_CONSTRUCTION_FORM_DTO = 'system/under-construction-form.dto',
  /** Technical work slot list API query parameters */
  UNDER_CONSTRUCTION_QUERY_DTO = 'system/under-construction-query.dto',
  /** Saved entry with SNMP notification data */
  SNMP_NOTIFICATION_ENTRY_DTO = 'system/snmp-notification-entry.dto',
  /** Saved SNMP notification data entries list API response body */
  SNMP_NOTIFICATION_PAGE_DTO = 'system/snmp-notification-page.dto',
  /** Saved SNMP notification data entries list API query parameters */
  SNMP_NOTIFICATION_QUERY_DTO = 'system/snmp-notification-query.dto',
  /** SNMP notification data */
  SNMP_NOTIFICATION_DTO = 'system/snmp-notification.dto',
  /** SNMP PDU details */
  SNMP_PDU_DTO = 'system/snmp-pdu.dto',
  /** SNMP sender details */
  SNMP_SENDER_DTO = 'system/snmp-sender.dto',
  /** SNMP varbind data */
  SNMP_VARBIND_DTO = 'system/snmp-varbind.dto',
  /** Proxy server own filters for find many APIs */
  PROXY_SERVER_FILTERS_DTO = 'system/proxy-server-filters.dto',
  /** Proxy server find many API query parameters */
  PROXY_SERVER_FIND_MANY_QUERY_DTO = 'system/proxy-server-find-many-query.dto',
  /** Proxy server find one API query parameters */
  PROXY_SERVER_FIND_ONE_QUERY_DTO = 'system/proxy-server-find-one-query.dto',
  /** Proxy server response body */
  PROXY_SERVER_FIND_DTO = 'system/proxy-server-find.dto',
  /** Proxy server create and update APIs request body */
  PROXY_SERVER_FORM_DTO = 'system/proxy-server-form.dto',
  /** Proxy server find many API response body */
  PROXY_SERVER_PAGE_DTO = 'system/proxy-server-page.dto',
  /** Proxy server partial update API request body */
  PROXY_SERVER_PARTIAL_FORM_DTO = 'system/proxy-server-partial-form.dto',
  /** Proxy server properties selection settings */
  PROXY_SERVER_SELECT_DTO = 'system/proxy-server-select.dto',
  /** Proxy server sorting settings */
  PROXY_SERVER_SORT_DTO = 'system/proxy-server-sort.dto',
}
